import useDevice from 'hooks/useDeviceType';
import { useEffect } from 'react';
import useGeoZoneStore from 'stores/geoZoneStore';
import { JsonResponseModel } from 'strapi/types';
import { DeviceType } from './types';

const usePartnershipPage = (
  pageData: JsonResponseModel,
  isPartnership: boolean,
  setRenderPage: (render: boolean) => void,
) => {
  const countryCode = useGeoZoneStore(x => x.countryCode);
  const devices = useDevice();

  useEffect(() => {
    if (!isPartnership) {
      setRenderPage(true);
    } else {
      const currentDevice = Object.keys(devices)
        .filter(key => devices[key] === true)
        .map(key => DeviceType[key]);

      const isDeviceCheckPassed =
        !pageData?.devices?.length ||
        (!pageData.devices.includes(DeviceType.isDesktop)
          ? pageData.devices.every(device => currentDevice.includes(device))
          : pageData.devices.some(device => currentDevice.includes(device)));

      const isCountryCheckPassed = pageData?.countries?.includes('All')
        ? !pageData.countries?.includes(countryCode)
        : pageData?.countries?.some(country => country === countryCode) ||
          (pageData && !pageData.countries?.length);

      if (isDeviceCheckPassed && isCountryCheckPassed) {
        setRenderPage(true);
      } else if (pageData && countryCode) {
        window.location.href = `/gold?notify=${pageData?.slug}-unavailable`;
      }
    }
  }, [countryCode, devices, isPartnership, pageData, setRenderPage]);
};

export default usePartnershipPage;
